import { tns } from '../../../thirdparty/tinyslider/tinyslider.js';

export function initProductScroller(){
    let slider = new tns({
        container: document.getElementById('dotd-slider'),
        rewind: true,
        lazyload: true,
        prevButton: document.getElementById('leftArrowClick'),
        nextButton: document.getElementById('rightArrowClick'),
        speed: 500,
        items: 1, // number items on mobile
        nav: true,
        navPosition: "bottom"
    });

    updateScrollerTopMargin();

    document.querySelector(".dotdScroller").classList.remove("invisible");
    window.addEventListener("resize", updateScrollerTopMargin);
}

function updateScrollerTopMargin(){
    // if the circle nav buttons are showing on the bottom of the slider,
    // add margin top to the slider so it is centered between the countdown and info
    const nav = document.querySelector(".tns-nav");
    const scroller = document.querySelector(".dotdScroller");
    if(!nav.hasAttribute("style") && window.innerWidth >= 1400 && !scroller.hasAttribute("style")){
        const navHeight = nav.offsetHeight;
        scroller.style.marginTop = navHeight + "px";
    }else if(!nav.hasAttribute("style") && window.innerWidth < 1400 && scroller.hasAttribute("style")){
        scroller.removeAttribute("style");
    }
}